import { useQuery } from '@tanstack/react-query';
import { Navigate, useParams } from 'react-router-dom';
import * as api from '../api/endpoints';
import { Spinner } from '../components/ui';
import { NotFound } from './NotFound';
import { Report } from './Report';

/** Server-backed report opened from the emailed link (/report/:reviewId). */
export function SharedReport() {
  const { reviewId } = useParams<{ reviewId: string }>();
  const query = useQuery({
    queryKey: ['report', reviewId],
    queryFn: () => api.getReport(reviewId ?? ''),
    enabled: Boolean(reviewId),
  });

  if (!reviewId) return <Navigate to="/" replace />;
  if (query.isPending) return <Spinner label="Loading report…" />;
  if (query.isError || !query.data)
    return <NotFound title="Report not found" message="This report link is invalid or has expired." />;
  return <Report data={query.data} />;
}
